
import GetAusstattungProduktObj from "../AusstattungProduktService";
import getRauchmelder from "./AddRauchmerlder"
import getBewegungsmelder from "./AddBewegungsmelder"
import getSteckdosen from "./AddSteckdosen"
import getSteckdosenAufputz from "./AddSteckdosenAufputz"
import getSteckdosenUsb from "./AddSteckdosenUsb"
// import getSteckdosenRahmen from "./AddSteckdosenRahmen"
import getTelefonDatenanschluss from "./AddTelefonDatenanschluss"
import getTelefonanschluss from "./AddTelefonanschluss"
import getRadioDatenSat from "./AddRadioDatenSat"
import getRadioDatenKabel from "./AddRadioDatenKabel"
// import getAnschlussdosenRahmen from "./AddAnschlussdosenRahmen"
import getDosenRahmen from "./AddDosenRahmen"
import getTuerkommunikation from "./AddTuerkommunikation"
import getSmartFunctions from "./AddSmartFunctions"
// import getHeizungRaum from "./AddHeizungRaum"
import getTaster from "./AddTaster"
import getAktoren from "../knx_ausstattung/AddAktoren";
import getSound from "./AddSound";
import getAudio from "./AddAudio";
import getFunctions from "./AddFunctions";
import getController from "./AddController";

export default function GenerateProjectService(projectIn, productList, lang){
    const needServer = {list: ['BTLS17101','BTLS17101WW','BTLS17101LG','BTLS17101SW','BTLS17101WWM','BTLS17101SWM','BTLC17101201','BTLC17101202','BTLC17101203','BTLC17101204','BTLC17101205','BTLC17101206','BTLC17101207','BTLC17101208','BTLC17101209','BTLC17101210','BTLC17101211','BTLC17101212','BTLC17101213','BTLC17101214','BTLC17101215','BTLC17101216','BTLC17101217','BTLC17101218','BTLC17101219','BTLC17101220','BTLC17101221','BTLC17101222','BTLC17101223','BTLC17101224','BTLC17101225','BTLC17101226','BTLC17101227','BTLC17101228','BTLC17101229','BTLC17101230','BTLC17101231','BTLC17101232','BTLC17101233','BTLC17101234','BTLC17101235','BTLC17101236','BTLC17101237','BTLC17101238','BTLC17101239','BTLC17101240','BTLC17101241','BTLC17101242','BTLC17101243','BTLC17101244','BTLC17101245','BTLC17101246','BTLC17101247','BTLC17101248','BTLC17101249','BTLC17101250','BTLC17101251','BTLC17101252','BTLC17101253','BTLC17101254','BTLC17101255','BTLC17101256','BTLC17101257','BTLC17101258','BTLC17101259','BTLC17101260','BTLC17101261','BTLC17101262','BTLC17101263','BTAL17101','BTES17101','BTAL17101AN','BTAL17101D','BTME17101C','BTME17101AT','BTAS17101WW','BTAS17101','BTA17101AL','BTA17101WW','BTA17101SW','BTA17101WWM','BTA17101SWM','BTA17101BFANM','BTA17101BFWW','BTA17101BFSW','BTA17101CH','BTA17101MO','BTCD17101','BTCD17101WW','BTCD17101SW','BTCD17101BR','BTCD17101GR','BTCD17101LG','BTCD17101GB','BTCD17101PT','BTLS17181','BTLS17181WW','BTLS17181LG','BTLS17181SW','BTLS17181WWM','BTLS17181SWM','BTLC17181201','BTLC17181202','BTLC17181203','BTLC17181204','BTLC17181205','BTLC17181206','BTLC17181207','BTLC17181208','BTLC17181209','BTLC17181210','BTLC17181211','BTLC17181212','BTLC17181213','BTLC17181214','BTLC17181215','BTLC17181216','BTLC17181217','BTLC17181218','BTLC17181219','BTLC17181220','BTLC17181221','BTLC17181222','BTLC17181223','BTLC17181224','BTLC17181225','BTLC17181226','BTLC17181227','BTLC17181228','BTLC17181229','BTLC17181230','BTLC17181231','BTLC17181232','BTLC17181233','BTLC17181234','BTLC17181235','BTLC17181236','BTLC17181237','BTLC17181238','BTLC17181239','BTLC17181240','BTLC17181241','BTLC17181242','BTLC17181243','BTLC17181244','BTLC17181245','BTLC17181246','BTLC17181247','BTLC17181248','BTLC17181249','BTLC17181250','BTLC17181251','BTLC17181252','BTLC17181253','BTLC17181254','BTLC17181255','BTLC17181256','BTLC17181257','BTLC17181258','BTLC17181259','BTLC17181260','BTLC17181261','BTLC17181262','BTLC17181263','BTA17181AL','BTES17181','BTAL17181AN','BTAL17181D','BTME17181C','BTME17181AT','BTAL17181','BTA17181WW','BTA17181','BTA17181SW','BTA17181WWM','BTA17181SWM','BTA17181ANM','BTA17181CH','BTA17181MO','BTCD17181','BTCD17181WW','BTCD17181SW','BTCD17181BR','BTCD17181GR','BTCD17181LG','BTCD17181GB','BTCD17181PT','BTLSCD1002','BTA1002','BTLSCD1001','BTA1001','BTLS1521SE','BTLS1521SEWW','BTLS1521SELG','BTLS1521SESW','BTLS1521SEWWM','BTLS1521SESWM','BTLC1521SE201','BTLC1521SE202','BTLC1521SE203','BTLC1521SE204','BTLC1521SE205','BTLC1521SE206','BTLC1521SE207','BTLC1521SE208','BTLC1521SE209','BTLC1521SE210','BTLC1521SE211','BTLC1521SE212','BTLC1521SE213','BTLC1521SE214','BTLC1521SE215','BTLC1521SE216','BTLC1521SE217','BTLC1521SE218','BTLC1521SE219','BTLC1521SE220','BTLC1521SE221','BTLC1521SE222','BTLC1521SE223','BTLC1521SE224','BTLC1521SE225','BTLC1521SE226','BTLC1521SE227','BTLC1521SE228','BTLC1521SE229','BTLC1521SE230','BTLC1521SE231','BTLC1521SE232','BTLC1521SE233','BTLC1521SE234','BTLC1521SE235','BTLC1521SE236','BTLC1521SE237','BTLC1521SE238','BTLC1521SE239','BTLC1521SE240','BTLC1521SE241','BTLC1521SE242','BTLC1521SE243','BTLC1521SE244','BTLC1521SE245','BTLC1521SE246','BTLC1521SE247','BTLC1521SE248','BTLC1521SE249','BTLC1521SE250','BTLC1521SE251','BTLC1521SE252','BTLC1521SE253','BTLC1521SE254','BTLC1521SE255','BTLC1521SE256','BTLC1521SE257','BTLC1521SE258','BTLC1521SE259','BTLC1521SE260','BTLC1521SE261','BTLC1521SE262','BTLC1521SE263','BTAL1521SE-L','BTES1521SE-L','BTAL1521SEAN-L','BTAL1521SED-L','BTME1521SEC-L','BTME1521SEAT-L','BTA1521SEWW','BTA1521SE','BTA1521SEAL','BTA1521SESW','BTA1521SEWWM','BTA1521SESWM','BTA1521SEANM','BTA1521SECH','BTA1521SEMO','BTCD1521SE','BTCD1521SEWW','BTCD1521SESW','BTCD1521SEBR','BTCD1521SEGR','BTCD1521SELG','BTCD1521SEGB','BTCD1521SEPT','BTLS17102','BTLS17102WW','BTLS17102LG','BTLS17102SW','BTLS17102WWM','BTLS17102SWM','BTLC17102201','BTLC17102202','BTLC17102203','BTLC17102204','BTLC17102205','BTLC17102206','BTLC17102207','BTLC17102208','BTLC17102209','BTLC17102210','BTLC17102211','BTLC17102212','BTLC17102213','BTLC17102214','BTLC17102215','BTLC17102216','BTLC17102217','BTLC17102218','BTLC17102219','BTLC17102220','BTLC17102221','BTLC17102222','BTLC17102223','BTLC17102224','BTLC17102225','BTLC17102226','BTLC17102227','BTLC17102228','BTLC17102229','BTLC17102230','BTLC17102231','BTLC17102232','BTLC17102233','BTLC17102234','BTLC17102235','BTLC17102236','BTLC17102237','BTLC17102238','BTLC17102239','BTLC17102240','BTLC17102241','BTLC17102242','BTLC17102243','BTLC17102244','BTLC17102245','BTLC17102246','BTLC17102247','BTLC17102248','BTLC17102249','BTLC17102250','BTLC17102251','BTLC17102252','BTLC17102253','BTLC17102254','BTLC17102255','BTLC17102256','BTLC17102257','BTLC17102258','BTLC17102259','BTLC17102260','BTLC17102261','BTLC17102262','BTLC17102263','BTAL17102','BTES17102','BTAL17102AN','BTAL17102D','BTME17102C','BTME17102AT','BTAS17102WW','BTAS17102','BTA17102AL','BTA17102BFWW','BTA17102BFSW','BTA17102WWM','BTA17102SWM','BTA17102BFANM','BTA17102WW','BTA17102SW','BTA17102CH','BTA17102MO','BTA17102BFAL','BTA17102BFWWM','BTCD17102','BTCD17102WW','BTCD17102SW','BTCD17102BR','BTCD17102GR','BTCD17102LG','BTCD17102GB','BTCD17102PT','BTLS17101P','BTLS17101PWW','BTLS17101PLG','BTLS17101PSW','BTLS17101PWWM','BTLS17101PSWM','BTLC17101P201','BTLC17101P202','BTLC17101P203','BTLC17101P204','BTLC17101P205','BTLC17101P206','BTLC17101P207','BTLC17101P208','BTLC17101P209','BTLC17101P210','BTLC17101P211','BTLC17101P212','BTLC17101P213','BTLC17101P214','BTLC17101P215','BTLC17101P216','BTLC17101P217','BTLC17101P218','BTLC17101P219','BTLC17101P220','BTLC17101P221','BTLC17101P222','BTLC17101P223','BTLC17101P224','BTLC17101P225','BTLC17101P226','BTLC17101P227','BTLC17101P228','BTLC17101P229','BTLC17101P230','BTLC17101P231','BTLC17101P232','BTLC17101P233','BTLC17101P234','BTLC17101P235','BTLC17101P236','BTLC17101P237','BTLC17101P238','BTLC17101P239','BTLC17101P240','BTLC17101P241','BTLC17101P242','BTLC17101P243','BTLC17101P244','BTLC17101P245','BTLC17101P246','BTLC17101P247','BTLC17101P248','BTLC17101P249','BTLC17101P250','BTLC17101P251','BTLC17101P252','BTLC17101P253','BTLC17101P254','BTLC17101P255','BTLC17101P256','BTLC17101P257','BTLC17101P258','BTLC17101P259','BTLC17101P260','BTLC17101P261','BTLC17101P262','BTLC17101P263','BTAL17101P','BTES17101P','BTAL17101PAN','BTAL17101PD','BTME17101PC','BTME17101PAT','BTAS17101PWW','BTA17101PAL','BTA17101PWW','BTA17101PSW','BTA17101PWWM','BTA17101PSWM','BTA17101BFPANM','BTA17101BFPWW','BTA17101BFPSW','BTA17101PCH','BTA17101PMO','BTCD17101PWW','BTCD17101PSW','BTCD17101PBR','BTCD17101PGR','BTCD17101PLG','BTCD17101PGB','BTCD17101PPT','BTLS1791WW','BTLS1791SW','TRDLS1790WW','BTA1791WW','BTA1791SW','BTCD1791WW','BTCD1791SW','BTLS1521S','BTLS1521SWW','BTLS1521SLG','BTLS1521SSW','BTLS1521SWWM','BTLS1521SSWM','BTLC1521S201','BTLC1521S202','BTLC1521S203','BTLC1521S204','BTLC1521S205','BTLC1521S206','BTLC1521S207','BTLC1521S208','BTLC1521S209','BTLC1521S210','BTLC1521S211','BTLC1521S212','BTLC1521S213','BTLC1521S214','BTLC1521S215','BTLC1521S216','BTLC1521S217','BTLC1521S218','BTLC1521S219','BTLC1521S220','BTLC1521S221','BTLC1521S222','BTLC1521S223','BTLC1521S224','BTLC1521S225','BTLC1521S226','BTLC1521S227','BTLC1521S228','BTLC1521S229','BTLC1521S230','BTLC1521S231','BTLC1521S232','BTLC1521S233','BTLC1521S234','BTLC1521S235','BTLC1521S236','BTLC1521S237','BTLC1521S238','BTLC1521S239','BTLC1521S240','BTLC1521S241','BTLC1521S242','BTLC1521S243','BTLC1521S244','BTLC1521S245','BTLC1521S246','BTLC1521S247','BTLC1521S248','BTLC1521S249','BTLC1521S250','BTLC1521S251','BTLC1521S252','BTLC1521S253','BTLC1521S254','BTLC1521S255','BTLC1521S256','BTLC1521S257','BTLC1521S258','BTLC1521S259','BTLC1521S260','BTLC1521S261','BTLC1521S262','BTLC1521S263','BTAL1521S-L','BTES1521S-L','BTAL1521SAN-L','BTAL1521SD-L','BTME1521SC-L','BTME1521SAT-L','BTA1521S','BTA1521SWW','BTA1521SAL','BTA1521SSW','BTA1521SWWM','BTA1521SSWM','BTA1521SANM','BTA1521SCH','BTA1521SMO','BTCD1521S','BTCD1521SWW','BTCD1521SSW','BTCD1521SBR','BTCD1521SGR','BTCD1521SLG','BTCD1521SGB','BTCD1521SPT']};

    let generatedProject = {
        code: null,
        name: projectIn.name,
        selectedAlternatives: (projectIn.selectedAlternatives !== undefined) ? projectIn.selectedAlternatives : {},
        floors: []
    };
    let generated_combinations = {
        name: projectIn.name,
        combinations: [],
        items: []
    };
    let systemProductList = [];
    let addSpannung = false;
    let actionsList = [];
    let allProductList = [];
    projectIn.floors.forEach( floorIn => {
        const floor = {
            id: floorIn.id,
            name: floorIn.name,
            type: floorIn.typePro,
            rooms: []
        };
        const floor_comb = {
            name: floorIn.name,
            combinations: [],
            subStructure: []
        };
        floorIn.rooms.forEach(roomIn => {
            const room = {
                id: roomIn.id,
                name: roomIn.name,
                type: roomIn.typePro,
                products: [],
                actions: []
            }
            let combinations = {
                name: room.name,
                type: roomIn.typePro,
                combinations: [],
                products: []
            };
            let schaltbare = []; let normal = []; let daten = {telefon:[],radio:[]}; let charger = [];
            // let aust_list = []; let aust_list_optional = [];
            const austattung_produkt = GetAusstattungProduktObj(projectIn, roomIn, lang);
            let productListInner = []; let optionalRahmen = [];

            //todo use algorithm to fill productListInner and systemProductList
            productListInner = productListInner.concat(getRauchmelder(roomIn, austattung_produkt));
            productListInner = productListInner.concat(getBewegungsmelder(roomIn, austattung_produkt));

            const steckdosen = getSteckdosen(roomIn, austattung_produkt);
            productListInner = productListInner.concat(steckdosen.productList);
            if (steckdosen.combinations.schaltbare.length) { schaltbare = schaltbare.concat(steckdosen.combinations.schaltbare); }
            if (steckdosen.combinations.normal.length) { normal = normal.concat(steckdosen.combinations.normal); }

            const steckdosen_aufputz = getSteckdosenAufputz(roomIn, austattung_produkt);
            productListInner = productListInner.concat(steckdosen_aufputz.productList);
            for(let k=0; k < steckdosen_aufputz.productList.length; k++) {
                for (let kk = 0; kk < steckdosen_aufputz.productList[k].count; kk++) {
                    normal.push([steckdosen_aufputz.productList[k].product]);
                }
            }

            const steckdosen_Usb = getSteckdosenUsb(roomIn, austattung_produkt);
            productListInner = productListInner.concat(steckdosen_Usb.productList);
            productListInner = productListInner.concat(steckdosen_Usb.chargerProductList);
            for(let k=0; k < steckdosen_Usb.productList.length; k++) {
                for (let kk = 0; kk < steckdosen_Usb.productList[k].count; kk++) {
                    normal.push([steckdosen_Usb.productList[k].product]);
                }
            }
            charger = charger.concat(steckdosen_Usb.charger);

            const telefonDatenauschluss = getTelefonDatenanschluss(roomIn, austattung_produkt);
            productListInner = productListInner.concat(telefonDatenauschluss.productList);
            for(let k=0; k < telefonDatenauschluss.cProducts.length; k++) {
                daten.telefon.push(telefonDatenauschluss.cProducts[k]);
            }

            const telefonAnschluss = getTelefonanschluss(roomIn, austattung_produkt);
            productListInner = productListInner.concat(telefonAnschluss.productList);
            for(let k=0; k < telefonAnschluss.cProducts.length; k++) {
                daten.telefon.push(telefonAnschluss.cProducts[k]);
            }

            const radioDatenSat = getRadioDatenSat(roomIn, austattung_produkt);
            productListInner = productListInner.concat(radioDatenSat.productList);
            for(let k=0; k < radioDatenSat.cProducts.length; k++) {
                daten.radio.push(radioDatenSat.cProducts[k]);
            }

            const radioDatenKabel = getRadioDatenKabel(roomIn, austattung_produkt);
            productListInner = productListInner.concat(radioDatenKabel.productList);
            for(let k=0; k < radioDatenKabel.cProducts.length; k++) {
                daten.radio.push(radioDatenKabel.cProducts[k]);
            }

            const rahmen = getDosenRahmen(roomIn, austattung_produkt, {schaltbare, normal, daten, charger}, projectIn.subProjectType === 'umbau');
            productListInner = productListInner.concat(rahmen.productList);
            productListInner = productListInner.concat(rahmen.chargerFrames);
            if (projectIn.subProjectType === 'umbau') {
                optionalRahmen = optionalRahmen.concat(rahmen.productList_optional);
                rahmen.productList_optional.forEach(p => { combinations.products.push({artikelnummer: p.product, factor: p.count, origin: 'rahmen 127'}); });
            }
            rahmen.combinations.forEach(comb => combinations.combinations.push(comb));

            const audio = getAudio(roomIn, austattung_produkt);
            productListInner = productListInner.concat(audio.productList);
            audio.productList.forEach(p => { combinations.products.push({artikelnummer: p.product, factor: p.count, origin: 'audio 133'}); });

            const taster = getTaster(roomIn, austattung_produkt, projectIn.selectedAlternatives, []);
            if(taster.list.length > 0){
                productListInner = productListInner.concat(taster.list);
                actionsList = actionsList.concat(taster.actions);
                room.actions = room.actions.concat(taster.actions);
                for ( let k = 0; k < taster.combinations.combinations.length; k++ ) {
                    combinations.combinations.push(taster.combinations.combinations[k]);
                }
                // console.log('taster', taster, combinations)
            }
            taster.productList_optional.forEach(p => { combinations.products.push({artikelnummer: p.product, factor: p.count, origin: 'taster, 145'}); });

            const raumController = getController(roomIn, austattung_produkt, projectIn.selectedAlternatives, actionsList);
            // console.log('raumcontroller', raumController)
            if(raumController.list.length > 0){
                productListInner = productListInner.concat(raumController.list);
                raumController.list.forEach(p => { combinations.products.push({artikelnummer: p.product, factor: p.count, origin: 'raumController 151'}); });
            }
            // console.log('combinations', combinations)
            // console.log('productlist', productList, 'count', productList.length);
            productListInner.forEach( p => {
                if (!p.product || p.product === '') { console.log('skipping empty product', p); return; }
                const productTmp = room.products.find(pi => pi.Artikelnummer.toString() === p.product.toString());
                if(productTmp === undefined){
                    const pp = productList.find(pl => pl.Artikelnummer.toString() === p.product.toString());
                    if(pp === undefined){ console.log('product not found', p); return; }
                    const productToPush = {...pp, count: p.count, actions: p.actions ? p.actions: []};
                    if(p.alt !== undefined){
                        const nlist = p.alt.map(pa => {
                            const altList = [];
                            pa.products.forEach(paPro => {
                                const ppa = productList.find(pl => pl.Artikelnummer.toString() === paPro.toString());
                                if(pp === undefined){
                                    return;
                                }
                                altList.push(ppa);
                            })
                            pa.products = altList;
                            return pa;
                        });
                        productToPush.productSwitch = nlist;
                    }
                    room.products.push(productToPush);
                }else {
                    productTmp.count += p.count;
                    productTmp.actions = productTmp.actions.concat(p.actions || []);
                }
            });
            optionalRahmen.forEach( p => {
                if (!p.product || p.product === '') { console.log('skipping empty product', p); return; }
                const productTmp = room.products.find(pi => pi.Artikelnummer.toString() === p.product.toString() && p.isOptional === true);
                if(productTmp === undefined){
                    const pp = productList.find(pl => pl.Artikelnummer.toString() === p.product.toString());
                    if(pp === undefined){ console.log('product not found', p); return; }
                    const productToPush = {...pp, count: p.count, actions: p.actions ? p.actions: [], isOptional: true};
                    if(p.alt !== undefined){
                        const nlist = p.alt.map(pa => {
                            const altList = [];
                            pa.products.forEach(paPro => {
                                const ppa = productList.find(pl => pl.Artikelnummer.toString() === paPro.toString());
                                if(pp === undefined){
                                    return;
                                }
                                altList.push(ppa);
                            })
                            pa.products = altList;
                            return pa;
                        });
                        productToPush.productSwitch = nlist;
                    }
                    room.products.push(productToPush);
                }else {
                    productTmp.count += p.count;
                    productTmp.actions = productTmp.actions.concat(p.actions || []);
                }
            });
            floor.rooms.push(room);
            allProductList = allProductList.concat(productListInner);
            floor_comb.subStructure.push(combinations);
            // console.log('room combinations', room.name, combinations)
        });
        generatedProject.floors.push(floor);
        generated_combinations.items.push(floor_comb);
    });
    const austattung_produkt = projectIn.floors.length && projectIn.floors[0].rooms.length
        ? GetAusstattungProduktObj(projectIn, projectIn.floors[0].rooms[0], lang) : [];

    //todo use algorithm to fill systemProductList
    // console.log('after rooms', allProductList.filter(i=>i.product===austattung_produkt["szenen"]));
    systemProductList = [];
    getTuerkommunikation(projectIn, austattung_produkt).forEach(p => {
        if (p.product !== undefined) {
            const pz = productList.find(pl => pl.Artikelnummer.toString() === p.product.toString());
            if (pz) {
                generatedProject = {
                    ...generatedProject,
                    floors: generatedProject.floors.map(floor => {
                        return {
                            ...floor,
                            rooms: floor.rooms.map(room => {
                                if (p.room.typePro === room.type && !p.assigned) {
                                    p = {...p, assigned: true};
                                    return {
                                        ...room,
                                        products: [...room.products, {...pz, count: p.count}]
                                    }
                                }
                                return room;
                            })
                        };
                    })
                };
                generated_combinations = {
                    ...generated_combinations,
                    items: generated_combinations.items.map(item => {
                        return {
                            ...item,
                            subStructure: item.subStructure.map(room => {
                                if (p.room.type === room.type) {
                                    return {
                                        ...room,
                                        products: [...room.products, {artikelnummer: p.product, factor: p.count, origin: 'tuerko 255'}]
                                    };
                                }
                                return room;
                            })
                        };
                    })
                };
            }
        }
    });
    systemProductList = systemProductList.concat(getSound(projectIn, austattung_produkt));
    const sm = getSmartFunctions(projectIn, austattung_produkt, generatedProject);
    let smartProducts = systemProductList.concat(sm.productList);
    let ignoreSmProduct = [];
    if (sm.cProducts.length) {
        sm.cProducts.forEach(p => {
            let comb = {
                frame: p.frame,
                factor: 1,
                orientation: 'H',
                controlElements: [{
                    position: 1,
                    insert: p.insert,
                    abdeckung: p.abdeckung
                }],
                origin: 'smartProducts, 276'
            };
            ignoreSmProduct.push(p.insert); ignoreSmProduct.push(p.frame); ignoreSmProduct.push(p.abdeckung);
            generated_combinations = {
                ...generated_combinations,
                items: generated_combinations.items.map(item => {
                    return {
                        ...item,
                        subStructure: item.subStructure.map(room => {
                            if (p.room.type === room.type) {
                                return {
                                    ...room,
                                    combinations: [...room.combinations, comb]
                                };
                            }
                            return room;
                        })
                    };
                })
            };
        });
    }
    // console.log('allproductslist before adding smartproducts', needServer, allProductList)
    let needCount = 0;
    allProductList.forEach(item => {
        // console.log('parsing', item, item.product, needServer[item.product], item.count)
        if (needServer.list.includes(item.product)) { needCount += item.count; }
    });
    const filteredgw = smartProducts.filter(i => i.product === austattung_produkt["iot"])[0];
    if (filteredgw) {
        filteredgw.count = 1;
        smartProducts = smartProducts.filter(i => i.product !== austattung_produkt["iot"]);
        smartProducts.push(filteredgw);
        // console.log('has gateway', filteredgw)
    }
    const filteredsv = smartProducts.filter(i => i.product === austattung_produkt["svServer"])[0];
    if (filteredsv) {
        filteredsv.count = 1;
        smartProducts = smartProducts.filter(i => i.product !== austattung_produkt["svServer"]);
        smartProducts.push(filteredsv);
        // console.log('has visu server', filteredsv)
    }
    // console.log('needCount total', needCount)
    if (needCount >= 20) {
        // needCount -= 20;
        const recomended_room = ["4b3a0860-836b-499f-8e28-f11c7f46e8e1"];
        let foundRoom = generatedProject.floors[0].rooms[0];
        generatedProject.floors.forEach(floor => {
            floor.rooms.forEach(room => {
                if (recomended_room.includes(room.type)) { foundRoom = room; }
            });
        });
        //console.log('foundRoom', foundRoom, austattung_produkt["svServer"]);
        if (austattung_produkt["svServer"] !== undefined) {
            const filtered = smartProducts.filter(i => i.product === austattung_produkt["svServer"])[0];
            if (!filtered) {
                smartProducts.push({
                    product: austattung_produkt["svServer"],
                    count: 1 ,
                    room: foundRoom
                })
                // console.log('pushed to smartProducts', austattung_produkt["svServer"]);
            }
        }
        if (austattung_produkt["iot"] !== undefined) {
            const filtered = smartProducts.filter(i => i.product === austattung_produkt["iot"])[0];
            if (!filtered) {
                smartProducts.push({
                    product: austattung_produkt["iot"],
                    count: 1 ,
                    room: foundRoom
                })
                // console.log('pushed to smartProducts', austattung_produkt["iot"]);
            }
        }
    }
    // console.log('needCount', needCount)
    // console.log('smartProducts', smartProducts.filter(i => i.product === austattung_produkt["szenen"]), allProductList.filter(i=>i.product === austattung_produkt["szenen"]));
    allProductList = allProductList.concat(smartProducts);
    smartProducts.forEach(p => {
        if (p.product !== undefined) {
            const pz = productList.find(pl => pl.Artikelnummer.toString() === p.product.toString());
            if (pz) {
                generatedProject = {
                    ...generatedProject,
                    floors: generatedProject.floors.map(floor => {
                        return {
                            ...floor,
                            rooms: floor.rooms.map(room => {
                                if (p.room.type === room.type && !p.assigned) {
                                    p = {...p, assigned: true};
                                    return {
                                        ...room,
                                        products: [...room.products, {...pz, count: p.count}]
                                    }
                                }
                                return room;
                            })
                        };
                    })
                };
                if (!ignoreSmProduct.includes(p.product)) {
                    generated_combinations = {
                        ...generated_combinations,
                        items: generated_combinations.items.map(item => {
                            return {
                                ...item,
                                subStructure: item.subStructure.map(room => {
                                    if (p.room.type === room.type && !p.assignedComb) {
                                        p = {...p, assignedComb: true}
                                        return {
                                            ...room,
                                            products: [...room.products, {artikelnummer: p.product, factor: p.count, origin: 'smartProducts 391'}]
                                        };
                                    }
                                    return room;
                                })
                            };
                        })
                    };
                } else {
                    const newlist = []; let searched = p.product
                    while (ignoreSmProduct.length) {
                        const tmpP = ignoreSmProduct.shift();
                        if (searched === tmpP) { searched = ''; }
                        else { newlist.push(tmpP); }
                    }
                    ignoreSmProduct = newlist;
                }
            }
        }
    });
    const akt = getAktoren(projectIn, austattung_produkt, actionsList);
    if(akt.length > 0){
        addSpannung = true;
        systemProductList = systemProductList.concat(akt);
    }
    if(addSpannung){
        systemProductList.push(
            {
                product: austattung_produkt["spannung"],
                count: 1
            }
        );
    }
    const functions = getFunctions(allProductList);
    // console.log('functions', functions)
    if(systemProductList.length > 0){
        const uv = {
            id: "Unterverteilung", //uuidv4(), todo
            name: "Unterverteilung",
            type: "cc245399-46d7-42fc-a576-0d11ecf0db71",
            products: [],
            installationLocations: [
                {
                    id: "InstallationLocation",
                    name: "[Unterverteiler]",
                    type: "4e6ab71c-beee-4f8b-9c77-1bc98394d104",
                    isSubdistribution: true,
                    products: [],
                    actions: []
                }
            ]
        }
        let combinations_uv = {
            name: "Unterverteilung",
            type: "cc245399-46d7-42fc-a576-0d11ecf0db71",
            combinations: [],
            products: []
        };
        const uvProducts = [];
        systemProductList.forEach( p => {
            combinations_uv.products.push({artikelnummer: p.product.toString(), factor: p.count});
            const productTmp = uvProducts.find(pi => pi.Artikelnummer.toString() === p.product.toString());
            if(productTmp === undefined){
                const pp = productList.find(pl => pl.Artikelnummer.toString() === p.product.toString());
                if(pp === undefined){
                    return;
                }
                const productToPush = {...pp, count: p.count};
                if(p.alt !== undefined){
                    const nlist = p.alt.map(pa => {
                        const altList = [];
                        pa.products.forEach(paPro => {
                            const ppa = productList.find(pl => pl.Artikelnummer? pl.Artikelnummer.toString() === paPro.toString() : false);
                            if(pp === undefined){
                                return;
                            }
                            altList.push(ppa);
                        })
                        pa.products = altList;
                        return pa;
                    });
                    productToPush.productSwitch = nlist;
                }
                uvProducts.push(productToPush);
            }else {
                productTmp.count += p.count;
            }
        });
        uvProducts.forEach(i => uv.installationLocations[0].products.push(i));
        uvProducts.forEach(i => uv.products.push(i));
        generatedProject.floors[0].rooms.push(uv);
        generated_combinations.items[0].subStructure.push(combinations_uv);
    }
    // var get_products_grouped = function(arr) {
    //     let obj = {}; let newArr = [];
    //     arr.forEach(item => {
    //         if (!obj[item.artikelnummer]) { obj[item.artikelnummer] = item; }
    //         else { obj[item.artikelnummer].factor += item.factor; }
    //     });
    //     for (let i in obj) { newArr.push(obj[i]); }
    //     return newArr;
    // };
    //
    // generated_combinations = {
    //     ...generated_combinations,
    //     items: generated_combinations.items.map(item => {
    //         return {
    //             ...item,
    //             subStructure: item.subStructure.map(room => {
    //                 return {
    //                     ...room,
    //                     products: get_products_grouped(room.products)
    //                 };
    //             })
    //         };
    //     })
    // };

console.log('generated home combinations', generated_combinations, productList, allProductList, systemProductList)
    return {...projectIn, generatedProject: generatedProject, functionsList: functions.list, functionsCats: functions.cats, combinations: generated_combinations};

}
